<a *ngIf="routeTo" class="btn btn-outline-secondary btn-sm float-right" [routerLink]="routeTo">
  <i class="fas fa-arrow-left"></i><span class="ms-2">{{text}}</span>
</a>
<button *ngIf="!routeTo" class="btn btn-outline-secondary btn-sm float-right" (click)="callBack($event)">
  <i class="fas fa-arrow-left"></i><span class="ms-2">{{text}}</span>
</button>
